import { ChevronLeft16 } from '@carbon/icons-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CpBody02Primary } from 'components/atoms/customer-portal/typography';
import { BgWrapper, PaddingSize } from '../common';
import { CpChatSidePane } from './chat-list';
import { BackIconWrapper, BackWrapper } from './components';
import { CpConversationPane } from './cp-conversation-pane';
import { CpChatProps } from './types';

export const CpChatForMobile: React.FC<CpChatProps> = ({
  activeContext,
  setActiveContext,
  data,
  onProjectConversationClick,
  setCreateNewConversationInProject,
  onEntityConversationClick,
  onFilterChange,
}) => {
  if (!activeContext) {
    return (
      <>
        <BackWrapper>
          <CpBody02Primary className="rl-cp-widget-title">
            <FormattedMessage id="projects.tabs.chat" />
          </CpBody02Primary>
        </BackWrapper>
        <BgWrapper paddingY={PaddingSize.None}>
          <CpChatSidePane
            activeConversation={activeContext}
            data={data}
            onAddConversationClick={(projectId: number) => {
              setCreateNewConversationInProject({
                name: '',
                projectId,
              });
            }}
            onProjectConverationClick={onProjectConversationClick}
            onEntityConversationClick={onEntityConversationClick}
          />
        </BgWrapper>
      </>
    );
  }

  return (
    <>
      <BackWrapper>
        <BackIconWrapper
          onClick={() => {
            setActiveContext(undefined);
          }}
        >
          <ChevronLeft16 />
        </BackIconWrapper>
        <CpBody02Primary className="rl-cp-widget-title">
          <FormattedMessage id="back" />
        </CpBody02Primary>
      </BackWrapper>
      <BgWrapper paddingY={PaddingSize.None}>
        <CpConversationPane
          setCreateNewConversationInProject={setCreateNewConversationInProject}
          activeContext={activeContext}
          setActiveContext={setActiveContext}
          data={data}
          onFilterChange={onFilterChange}
        />
      </BgWrapper>
    </>
  );
};
